async function bootstrapPlatform(): Promise<void> {
  if (window.importMapInjector) {
    await window.importMapInjector.initPromise;
  }

  const rootConfigModule = '@cedi-carbon/root-config';
  await import(/* @vite-ignore */ rootConfigModule);
}

function stringifyBootstrapError(error: unknown): string {
  if (error instanceof Error) {
    return [error.name, error.message, error.stack].filter(Boolean).join('\n');
  }

  return String(error);
}

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

void bootstrapPlatform().catch(error => {
  const errorText = stringifyBootstrapError(error);
  const failure = document.createElement('main');
  failure.className = 'platform-bootstrap-error';
  failure.innerHTML = `
    <h1>平台暂时无法启动</h1>
    <p>请刷新页面重试；如问题持续，请联系平台技术支持。</p>
    <details>
      <summary>查看启动错误</summary>
      <pre>${escapeHtml(errorText)}</pre>
    </details>
    <button type="button">重新加载</button>
  `;
  failure.querySelector('button')?.addEventListener('click', () => {
    window.location.reload();
  });
  document.body.replaceChildren(failure);
  console.error(error);
});
